import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useToast } from '@/components/ui/use-toast'
import { trpc } from 'src/trpc'
import { Separator } from '@/components/ui/separator'
import { useStoreState } from '@store/hooks'
import AdminItem from './AdminItem'
import useCurrentAgency from '@/agency/hooks/useCurrentAgency'
import { Heading } from '@/components/ui/heading'
import { Card, CardContent } from '@/components/ui/card'
import { MemberInfoFormValues } from '@/agencyMember/hooks/useAgencyMemberInfoSchema'
import { AdminAddForm } from './AdminAddForm'

export const AdminUsersList = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const [loading, setLoading] = useState(false)
  const agency = useCurrentAgency()
  const agencyMembers = useStoreState((state) => state.agencyMembers.entries)

  const handleInvite = async ({
    email,
    firstName,
    lastName,
  }: MemberInfoFormValues) => {
    setLoading(true)
    try {
      // This creates and invites the new agency member
      await trpc.agencyMember.inviteAgencyMember.mutate({
        agencyId: String(agency?.id),
        email,
        firstName,
        lastName,
      })

      toast({
        title: t('AdminUsersList.inviteSuccess', {
          email: email,
        }),
        description: t('AdminUsersList.inviteSuccessDesc'),
        variant: 'success',
      })
    } catch (error) {
      toast({
        title: t('AdminUsersList.inviteFailed', {
          email,
        }),
        description: t('AdminUsersList.inviteFailedDesc'),
        variant: 'destructive',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="tw-space-y-3">
      <Heading>{t('AdminUsersList.heading')}</Heading>
      <p className="tw-max-w-[600px] tw-text-sm tw-text-gray-500">
        {t('AdminUsersList.description')}
      </p>
      <Card>
        <CardContent className="tw-mt-6">
          <AdminAddForm loading={loading} onClick={handleInvite} />
          <Separator className="tw-my-6" />
          <div>
            {!agencyMembers?.length && (
              <p className="tw-text-center tw-text-gray-500">
                {t('AdminUsersList.noAdmins')}
              </p>
            )}
            {agencyMembers?.map((agencyMember, index) => (
              <AdminItem key={index} {...agencyMember} />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
